/**
 * Clip API
 */
import { defaults, get, patch, post, delete as _delete } from "axios";
import {getCurrentAuthToken} from '../auth/user-meta';

defaults.headers.common['Accept'] = 'application/json';
defaults.headers.post['Content-Type'] = 'application/json';


export default {
    /**
     * Get Clipd Place Id Lists
     */
    getClipedPlaceLists(token) {
        if(token){
            return new Promise((resolve, reject) => {
                let url = `${process.env.API_BASE_URL}clip/place`,
                    config = {
                        headers: {
                            auth_token: token,
                        }
                    };
    
                get(url, config)
                    .then(res => {
                        resolve(res)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        }else{
            return new Promise((resolve, reject) => {
                getCurrentAuthToken()
                    .then(id_token => {
                        let url = `${process.env.API_BASE_URL}clip/place`,
                            config = {
                                headers: {
                                    auth_token: id_token,
                                }
                            };
            
                        get(url, config)
                            .then(res => {
                                resolve(res)
                            })
                            .catch(error => {
                                reject(error)
                            })
                    })
                    .catch(err => {
                        reject(err)
                    })                
            })
        }
    },


    /**
     * Get Clip Status of Place Id
     * isCliped or not
     */
    getPlaceIdStatus(place_id, token) {
        return new Promise((resolve, reject) => {
            let url = `${process.env.API_BASE_URL}clip/place/${place_id}`,
                config = {
                    headers: {
                        auth_token: token,
                    }
                };

            get(url, config)
                .then(res => {
                    resolve(res)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },


    /**
     * Remove Bookmark of a certain article
     * @param {arrayList} params 
     */
    removePlaceIdClip(place_id, token) {
        return new Promise((resolve, reject) => {
            let url = `${process.env.API_BASE_URL}clip/place/${place_id}`,
                config = {
                    data:[],
                    headers: {
                        auth_token: token,
                    }
                };

            _delete(url, config)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
        })
    },


    /**
     * Add To Favorite
     * @param language_id
     * @param place_id
     */
    addPlaceIdClip(param, token){
        return new Promise((resolve, reject) => {
            let url = `${process.env.API_BASE_URL}clip/place`,
                config = {
                    headers: {
                        auth_token: token,
                    }
                },
                params= {
                    place_id: param.placeId,
                    language_id: param.lang_id
                };

            post(url, params, config)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        }) 
    },



    /**
     * Get Place Details Data 
     * @param place_id
     * @param language_code [en, jp,]
     */
    getPlaceDeatils(place_ids, language_code) {
        if(!place_ids && place_ids.length < 0) return [];

        let places_detail = place_ids.map((place_id) => {
            return new Promise((resolve, reject) => {
                let url = `${process.env.API_BASE_URL}place/detail/${place_id}/${language_code}`;
                get(url)
                    .then(res => {
                        if(res.status === 200){
                            let info = res.data.body;
                            // console.log(info.place_photo);
                            var keys = Object.keys(info.place_photo)
                            var first_image_key = keys[0] || undefined;
                            
                            var adi_keys = Object.keys(info.matcha_additional_data.place_photo)
                            var matcha_photo = info.matcha_additional_data.place_photo;

                            var data = {
                                id: info.place_master.place_id,
                                master_id: info.place_master.PlaceMasterID,
                                master_name: info.place_master.place_master_name,
                                title : info.place_detail.name,
                                matcha_data: {
                                    title : info.matcha_additional_data.place_detail.override_translated_place_title,
                                    thumbnail: (adi_keys.length > 0 ) 
                                    ? `${process.env.PLACE_ATTACHMENT}additional/${matcha_photo[0].path}?w=280` : ''
                                },
                                thumbnail: (first_image_key != void 0 && typeof first_image_key !== undefined) 
                                    ? `${process.env.PLACE_ATTACHMENT}${info.place_photo[first_image_key].photo_reference}?w=280` : ''
                            };
                            resolve(data);
                        }
                        resolve([])
                    })
                    .catch(error => {
                        // console.log(error)
                        resolve([])
                    })
            })
        })

        return new Promise((resolve, reject) => {
            Promise.all(places_detail)
                .then(datas => {
                    var filtered_data = datas.filter( (data) => {
                        return data.length !== 0;
                    });                    
                    resolve(filtered_data);
                })
        })

    },

}



// WEBPACK FOOTER //
// ./src/api/clip_place.js